const CARD_ELEMENT_STYLE = {
  base: {
    color: "#32325d",
    fontSize: "16px",
    fontSmoothing: "antialiased",
    "::placeholder": {
      color: "#ccc"
    }
  },
  invalid: {
    color: "#e5424d",
    ":focus": {
      color: "#303238"
    }
  }
}

// Shared Stripe Elements mounting, used by both the payment and
// payment-method Stimulus controllers in place of the old
// WrappedStripeProvider/ElementsWrappedCardForm React components.
export function mountCardElements(stripe, { cardNumber, cardExpiry, cardCvc }) {
  const elements = stripe.elements()
  const cardNumberElement = elements.create("cardNumber", { style: CARD_ELEMENT_STYLE })
  const cardExpiryElement = elements.create("cardExpiry", { style: CARD_ELEMENT_STYLE })
  const cardCvcElement = elements.create("cardCvc", { style: CARD_ELEMENT_STYLE, placeholder: "123" })

  cardNumberElement.mount(cardNumber)
  cardExpiryElement.mount(cardExpiry)
  cardCvcElement.mount(cardCvc)

  return { cardNumberElement, cardExpiryElement, cardCvcElement }
}
